import { withTranslation } from "react-i18next";
import HotelInfo from './HotelInfo';

export default withTranslation()(HotelInfo);